import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "card__inner" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("p", null, null, -1);
const _hoisted_4 = { class: "flex-align-center" };
const _hoisted_5 = { key: 1 };
import { t } from "@/utils/lang.util";
// import WhatsappNumber from "@/components/WhatsappNumber.vue";
import QRCodeGenerator from "@/components/QRCodeGenerator.vue";
import { setLoadingState } from "@/utils/navigation.util";
import { getWALink } from "@/utils/index";
import { computed, onMounted } from 'vue';
import ParentService from "@/services/parent.service";
import { DeviceTypes } from "@/types/ConfigTypes";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WhatsappCard',
    props: ['phone'],
    setup(__props) {
        const props = __props;
        const buttonClicked = () => {
            ParentService.openUrl(getWALink(phone.value, '', DeviceTypes.MOBILE), '_blank');
            // ParentService.openUrl(getWALink(props.phone, t('channels.whatsapp.initial_text_msg'), DeviceTypes.MOBILE), '_blank')
        };
        const whatsappUrl = computed(() => {
            // return 'https://wa.me/'+this.phone.replace('+','')
            // return 'https://web.whatsapp.com/send?phone=+'+this.phone.replace('+','')+'&text='+this.$t('channels.whatsapp.initial_text_msg')
            return getWALink(phone.value, '', DeviceTypes.DESKTOP);
            // return getWALink(props.phone, t('channels.whatsapp.initial_text_msg'), DeviceTypes.DESKTOP)
        });
        const phone = computed(() => {
            return props.phone.replace('-requested', '');
        });
        const isMobile = computed(() => {
            return ParentService.isMobile();
        });
        const startConversation = (() => {
            ParentService.openUrl(whatsappUrl.value, '_blank');
        });
        onMounted(() => {
            setLoadingState(false);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (!_unref(isMobile))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createTextVNode(_toDisplayString(_ctx.$t('channels.whatsapp.qr_code_title')) + " ", 1),
                        _hoisted_3
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_4, [
                    (!_unref(isMobile))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            onClick: buttonClicked
                        }, [
                            _createVNode(QRCodeGenerator, {
                                url: _unref(whatsappUrl),
                                size: 160
                            }, null, 8, ["url"])
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("button", {
                                onClick: startConversation,
                                class: "btn__primary"
                            }, _toDisplayString(_unref(t)('channels.whatsapp.button_text')), 1)
                        ]))
                ])
            ]));
        };
    }
});
